<template>
  <div class="adminStats">
    <statistiques-form />
    <statistiques-tableau />
    <statistiques-graphe />
  </div>
</template>

<script>
import StatistiquesForm from './atoms/statistiques/StatistiquesForm.vue'
import StatistiquesTableau from './atoms/statistiques/StatistiquesTableau.vue'
import StatistiquesGraphe from './atoms/statistiques/StatistiquesGraphe.vue'

export default {
  components: {
    'statistiques-form': StatistiquesForm,
    'statistiques-tableau': StatistiquesTableau,
    'statistiques-graphe': StatistiquesGraphe
  }
}
</script>
